import * as React from 'react';
import { withRouter } from 'react-router-dom';

class LoginLayout extends React.Component {

    render() {
        return (
        <div>
             {this.props.children}
        </div>
        );
    }
};

export default withRouter(LoginLayout);
